/* List of data types to fetch. */
export const SERIES = 'series';
export const COMPARISON = 'comparison';
export const PERCENTAGE = 'percentage';
export const CAMPAIGNS = 'campaigns';
export const MARKDOWN = 'markdown';
